<script>
	import { createEventDispatcher } from "svelte";
	import {
		Button,
		Modal,
		ModalBody,
		ModalFooter,
		ModalHeader,
	} from "@sveltestrap/sveltestrap";

	export let isOpen = false;

	const dispatch = createEventDispatcher();
	let nextStep = "collect";

	function close() {
		dispatch("close");
	}

	function confirm() {
		dispatch("confirm", { returnToHomeLot: nextStep === "homeLot" });
	}
</script>

<Modal {isOpen} toggle={close} centered>
	<ModalHeader toggle={close}>Complete work order</ModalHeader>
	<ModalBody>
		<p class="mb-4 my-2">
			Confirm that all fixes are complete, and any issues that couldn't be
			fixed have been accounted for.
		</p>
		<p class="my-2"><b>Next step for this vehicle:</b></p>
		<div class="form-check my-2">
			<input
				class="form-check-input"
				type="radio"
				name="nextStep"
				id="next-step-collect"
				value="collect"
				bind:group={nextStep}
			/>
			<label class="form-check-label my-1" for="next-step-collect">
				It's ready for GetGo to collect from the workshop
			</label>
		</div>
		<div class="form-check">
			<input
				class="form-check-input"
				type="radio"
				name="nextStep"
				id="next-step-home-lot"
				value="homeLot"
				bind:group={nextStep}
			/>
			<label class="form-check-label" for="next-step-home-lot">
				We'll move it back to its home lot
			</label>
		</div>
	</ModalBody>
	<ModalFooter>
		<Button class="themeButton backButton" on:click={close}>Cancel</Button>
		<Button class="themeButton primary" on:click={confirm}>Confirm</Button>
	</ModalFooter>
</Modal>
